
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium-employer-status",
      function () {
        return require("private-next-pages/premium-employer-status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium-employer-status"])
      });
    }
  